<template>
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex'
import surveyApi from '@/api/survey'

export default {
  inject: ['setSurvey', 'setView'],
  data() {
    return {
      isLoading: false,
      surveys: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    surveys(items) {
      let item

      if (this.selectedBot.type === 'phyathai') {
        item = items.find((item) => {
          if (this.selectedBot.pageid === '450523781782424') {
            return item.id === '27'
          }
          return item.id === '1'
        })
      } else {
        if (!items.length === 1) return
        item = items[0]
      }

      if (item && item.is_used) {
        this.setSurvey(item)
        this.setView('detail')
      }
    }
  },
  created() {
    this.fetchSurveys()
  },
  methods: {
    async fetchSurveys() {
      try {
        this.isLoading = true

        const response = await surveyApi.getAll({
          params: {
            page_id: this.selectedBot.pageid
          }
        })

        if (response.status === 200) {
          this.surveys = response.data.data
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/survey/SurveySelect.vue